export function checkSandboxFreeEligibilityWithEditions(eligibleForFreeOnSandbox, parentCapabilitySet, appSupportsEdition, selectedEditionType) {
  // Check basic eligibility conditions
  if (!eligibleForFreeOnSandbox || !appSupportsEdition || !parentCapabilitySet) {
    return false;
  }

  // If no edition type is selected, eligibility is granted
  if (!selectedEditionType) {
    return true;
  }

  // Check for the STANDARD edition eligibility
  if (selectedEditionType === 'STANDARD' && (parentCapabilitySet === 'ADVANCED' || parentCapabilitySet === 'STANDARD')) {
    return true;
  }

  // Check for ADVANCED edition eligibility
  if (selectedEditionType === 'ADVANCED' && parentCapabilitySet === 'ADVANCED') {
    return true;
  }

  // If none of the conditions are met, return false
  return false;
}